<template>
  <header id="header" class="Header">
    <div class="Header__fixed">
      <div class="HeaderLogo">
        <a href="/">
          <img v-if="tenantId == 'equans'" class="neg" src="assets/symbols/logo_equans_neg.svg"
            alt="Logo Equans Switzerland" />
          <img v-if="tenantId == 'equans'" class="pos" src="assets/symbols/logo_equans_pos.svg"
            alt="Logo Equans Switzerland" />
          <img v-if="tenantId == 'kuma'" class="neg" src="assets/symbols/logo_kuma_neg.svg"
            alt="Logo Kummler+Matter EVT AG" />
          <img v-if="tenantId == 'kuma'" class="pos" src="assets/symbols/logo_kuma_pos.svg"
            alt="Logo Kummler+Matter EVT AG" />
        </a>
      </div>

      <div class="HeaderContent">
        <div class="HeaderContent__meta">
          <ul>
            <li v-for="link in metaMenuLinks" :key="link.link.label" data-is-metanavigation="true">
              <a v-if="link.link.url" :href="link.link.url.path" :title="link.link.label">{{ link.link.label }}</a>
            </li>
          </ul>
        </div>

        <div class="HeaderContent__language">
          <div class="HeaderContent__language__preview">
            <span>{{ currentLanguage }}<i class="fal fa-angle-down"></i></span>
          </div>

          <div class="HeaderContent__language__dropdown" v-if="showLanguageSwitch">
            <ClientOnly>
              <template v-for="(language, i) in languageLinks" :key="`lang_${i}`">
                <a :href="language?.to" :title="getLanguageName(language.code)" :class="{ active: language.active }">
                  {{ language.code.toUpperCase() }}
                </a>
              </template>
            </ClientOnly>
          </div>

        </div>

        <div class="HeaderContent__ctas">
          <div class="etx-button-list ButtonList">
            <a v-if="openPositionsPage?.uri?.path" class="etx-button Button" :href="openPositionsPage?.uri?.path"
              :title="openPositionsPage?.title">
              <div class="etx-button__text Button__text">
                <span>{{ openPositionsPage?.title }}</span>
              </div>
            </a>

            <div v-if="onCallServicePhone" class="etx-button Button on-call PopupPikettButton"
              :href="`tel:${onCallServicePhone}`" :title="callButtonText">
              <div class="etx-button__icon Button__icon">
                <i class="far fa-phone"></i>
              </div>
              <div class="etx-button__text Button__text">
                <span class="font-size-smaller font-weight-light">{{
                  callButtonText
                  }}</span>
                <span>{{ onCallServicePhone }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="HeaderContent__nav">
          <ul>
            <li v-for="(link, index) in mainMenuLinks" :key="index">
              <span :data-dropdown-id="index + 1">{{ link.link.label }}</span>
            </li>
          </ul>
        </div>

        <div class="HeaderContent__search" v-if="false">
          <span class="etx-icon Icon large" data-dropdown-id="6">
            <i class="fat fa-search"></i>
          </span>
        </div>
      </div>

      <div class="HeaderNavToggle">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div v-for="(menuItem, i) in sortedData.slice(0, 5)" :key="i" class="Header__dropdown" :data-dropdown-id="i + 1">
      <div class="Header__dropdown__content">
        <div class="Header__dropdown__content__back">
          <div class="etx-icon Icon large">
            <i class="fat fa-long-arrow-left"></i>
          </div>
        </div>

        <div class="Header__dropdown__content__intro">
          <div>
            <div class="etx-text Text">
              <p class="font-h3">{{ menuItem?.fieldHeaderTitle }}</p>
              <p>{{ menuItem?.fieldHeaderDescription }}</p>
            </div>
            <div class="etx-button-list ButtonList">
              <a class="etx-button Button minimal" :href="menuItem?.path?.alias
                  ? `/${menuItem?.langcode}${menuItem?.path?.alias}`
                  : `/${menuItem?.langcode}/node/${menuItem?.id}`
                " :title="menuItem?.fieldHeaderTitle">
                <div class="etx-button__text Button__text">
                  <span>{{ nodeOverviewLinkText }}</span>
                </div>
                <div class="etx-button__icon Button__icon">
                  <i class="far fa-long-arrow-right"></i>
                </div>
              </a>
            </div>
          </div>

          <div>
            <div v-if="menuItem?.fieldHeaderButton" class="etx-card Card CardLink has-link"
              :class="menuItem.buttonStyle ? `bg-${menuItem.buttonStyle}` : 'bg-secondary'">
              <a class="etx-card__link Card__link" :href="menuItem.fieldHeaderButton.uri.path"
                :title="menuItem.fieldHeaderButton.title">
              </a>
              <div class="etx-card__item Card__item pv-0 grow-1"></div>

              <div class="etx-card__item Card__item ph-75 pv-75">
                <div class="etx-item Item fullwidth av-bottom">
                  <div class="etx-item__text Item__text">
                    <p class="font-size-large font-weight-bold">
                      {{ menuItem.fieldHeaderButton.title }}
                    </p>
                  </div>

                  <div class="etx-item__icon Item__icon">
                    <div class="Icon">
                      <i class="far fa-long-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="menuItem?.fieldHeaderButton2" class="etx-card Card CardLink has-link"
              :class="menuItem.button2Style ? `bg-${menuItem.button2Style}` : 'bg-primary'">
              <a class="etx-card__link Card__link" :href="menuItem.fieldHeaderButton2.uri.path"
                :title="menuItem.fieldHeaderButton2.title">
              </a>

              <div class="etx-card__item Card__item pv-0 grow-1"></div>

              <div class="etx-card__item Card__item ph-75 pv-75">
                <div class="etx-item Item fullwidth av-bottom">
                  <div class="etx-item__text Item__text">
                    <p class="font-size-large font-weight-bold">
                      {{ menuItem.fieldHeaderButton2.title }}
                    </p>
                  </div>

                  <div class="etx-item__icon Item__icon">
                    <div class="Icon">
                      <i class="far fa-long-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="Header__dropdown__content__main">
          <div class="HeaderDropdownSearch" v-if="menuItem?.hasLocationSearch">
            <LocationSearchBar />
          </div>
          <div class="HeaderDropdownNavigation">
            <ul>
              <li v-for="(link, index) in mainMenuLinks[i]?.subtree" :key="index">
                <template v-if="link.link.url?.path !== ''">
                  <a :href="link.link.url?.path" :title="link.link.label" :target="link.link.attribute">{{
                    link.link.label }}</a>
                </template>
                <template v-else>
                  <span>{{ link.link.label }}</span>
                </template>
                <ul>
                  <li v-for="(sublink, subindex) in link.subtree" :key="subindex">
                    <template v-if="sublink.link.url?.path !== ''">
                      <a :href="sublink.link.url?.path" :title="sublink.link.label">{{ sublink.link.label }}</a>
                    </template>
                    <template v-else>
                      <span>{{ sublink.link.label }}</span>
                    </template>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
  <Popup identifier="pikett-popup" />
</template>

<script lang="ts" setup>
const { $texts } = useNuxtApp()
const tenantId = useTenant()
const languages: ComputedRef<LanguageLink[]> = useLanguageLinks()

const route = useRoute()
const isHomepage = computed(() => /^home___.{2}$/.test(route.name ?? ''))
const isProject = computed(() => (route.name ?? '').includes('-project-pid___'))
const languagesHp = computed(() => {
  return [
    {
      code: "de",
      active: route.path === "/de",
      to: "/de"
    },
    {
      code: "fr",
      active: route.path === "/fr",
      to: "/fr"
    },
    {
      code: "it",
      active: route.path === "/it",
      to: "/it"
    },
    ...(
      tenantId !== 'kuma'
        ? [{
            code: "en",
            active: route.path === "/en",
            to: "/en"
          }]
        : []
    )
  ]
})

const currentLanguage = useCurrentLanguage()
const languageLinks = computed(() => {
  if (isHomepage.value) {
    return languagesHp.value.filter((l) => l.code !== currentLanguage.value)
  }
  return languages.value.filter((l) => l.code !== currentLanguage.value)
})
const showLanguageSwitch = computed(() => (!isProject.value && languageLinks.value.length >= 1))
const initData: Ref<InitData> = await useInitData()
const { metaMenuLinks, mainMenuLinks, globalConfig } = initData.value
const {
  onCallServicePhone,
  openPositionsPage,
  nodeOverviewLinkText,
  locationSearchMenuPage,
} = globalConfig

type LanguageLink = {
  code: string
  title: string
  active: boolean
  to: string
}

type NodeHeaderMetaInfoItem = {
  id: string
  fieldHeaderTitle: string
  fieldHeaderDescription: string
  langcode: string
  path?: {
    alias: string
  }
  fieldHeaderButton?: {
    uri: {
      path: string
    }
    title: string
  }
  fieldHeaderButton2?: {
    uri: {
      path: string
    }
    title: string
  }
  buttonStyle?: string
  button2Style?: string
  hasLocationSearch: boolean
}

// Translatable strings
const callButtonText = computed(() =>
  $texts('header.call_button_text', '24/7 on-call service'),
)

// Helper function to get language name by code
// Used in the language dropdown
const getLanguageName = (code: string): string => {
  const languageNames: Record<string, string> = {
    en: 'English',
    de: 'Deutsch',
    fr: 'Français',
    it: 'Italien',
  }

  return languageNames[code] || code
}

// Fetch node title & description for each first level main menu link
// See ./query.nodeHeaderMetaInfo.graphql
async function getNodeHeaderMetaInfo(items: object[]) {
  const nids = items.map((item) => item.nid)
  const { data, error } = await useAsyncData(
    'nodeHeaderMetaInfo-' + nids.join('-'),
    async () => {
      return await useGraphqlQuery('nodeHeaderMetaInfo', { nids: nids }).then(
        (v) => {
          const enrichedData = v.data?.entityQuery?.items.map((item) => {
            const match = items.find((i) => i.nid === item.id)
            if (match) {
              return {
                ...item,
                hasLocationSearch: match.mid === locationSearchMenuPage?.id,
              }
            }
            return item
          })
          return enrichedData ?? []
        },
      )
    },
  )
  return { data, error }
}

// Compose an array of objects with node and menu ids for each first level
// of the main menu
const mainMenuLinkEntityIds = mainMenuLinks
  .map((link) =>
    link.link.url && 'entity' in link.link.url
      ? {
        nid: link.link.url.entity?.id,
        mid: link.link?.content.id,
      }
      : undefined,
  )
  .filter((id) => id !== undefined)

const { data: nodeHeaderMetaInfo } = await getNodeHeaderMetaInfo(
  mainMenuLinkEntityIds,
)

// GraphQL does not guarantee the order of the results
// Sort the results based on the order of the main menu links by matching node id's
const sortedData = mainMenuLinkEntityIds.map((i) => {
  return (nodeHeaderMetaInfo.value as NodeHeaderMetaInfoItem[]).find(
    (item) => item.id === i.nid,
  )
})
</script>
